<template>
  <div>
    <SelectClient ref="clientData"/>

    <div class="row mt-1">
      <div class="col-md-8">
        <template v-for="(drug, index) in drugsInOrder">
          <div class="drugSelected">
            <DrugSelect
              ref="selectedDrug"
              :customData="{city_id: locality.city_id, site_id: locality.project_id}"
              :onSelect="(d, hardRefresh = null) => updateDrugData(d, index)"
              :selectedDrug="drug"
            />
            <div class="text-right mb-2">
              <LoadingButton
                title="Отправить препарат в чат"
                :loading="sendDrugToChatLoading"
                type="button"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => sendDrugToChat(drug, index)"
                className="btn btn-outline-success"
              />
            </div>
          </div>
        </template>
        <div class="drugSelected">
          <DrugSelect
            ref="newDrug"
            :onSelect="(d) => updateDrugData(d)"
          />
        </div>
      </div>
      <div class="col-md-4">
        <OrderPriceDetails
          ref="priceDetails"
          :saveOrder="() => updateOrder()"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <DeliveryData ref="DeliveryData"/>
      </div>
    </div>

  </div>
</template>

<script>

import SelectClient from "@/components/clients/SelectClient.vue";
import DeliveryData from "@/views/orders/components/DeliveryData.vue";
import DrugSelect from '@/components/drugs/DrugSelectForOrder'
import OrderPriceDetails from "@/components/orders/OrderPriceDetails.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  props: ['order', 'locality', 'sendMessage'],
  components: {LoadingButton, OrderPriceDetails, DrugSelect, DeliveryData, SelectClient},
  data() {
    return {
      sendDrugToChatLoading: false,
      drugsInOrder: [],
    }
  },
  watch: {
    // 'locality': {
    //   handler: function (val, oldVal) {
    //     this.updatePrices();
    //   },
    //   deep: true
    // },
    // 'order.drugs': {
    //   handler: function (val, oldVal) {
    //     this.updatePrices();
    //   },
    //   deep: true
    // },
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
  created() {
    this.$store.dispatch('orders/setEditNewOrder', {
      drugs: [],
      price: 0,
      extra_options: {},
    });
  },
  methods: {
    async sendDrugToChat(drug, index) {
      // console.log(drug, index, this.drugsInOrder[index]);
      drug = {...this.drugsInOrder[index]};
      this.sendDrugToChatLoading = true;
      await this.$refs.selectedDrug[index].getDrugInfo();
      await this.sendMessage({
        drug,
        projectInfo: this.$refs.selectedDrug[index].projectInfo[drug.id][this.locality.project_id]
      });
      this.sendDrugToChatLoading = false;
    },
    updateOrder() {

    },
    updateDrugData(drug = null, i = null) {
      if (!drug && i === null) return;
      // console.log(drug, i);
      if (!drug && i !== null) {
        this.drugsInOrder[i] = null;
        this.drugsInOrder = this.drugsInOrder.filter((d) => d);
        return;
      }
      if (i === null) {
        this.$refs.newDrug.drug = null;
        if (this.drugsInOrder.find((d) => d.id === drug.id)) return;
        this.drugsInOrder.push({...drug});
      } else {
        if (this.drugsInOrder.find((d, index) => i !== index && d.id === drug.id)) {
          this.updateDrugData(null, i);
          return;
        }
        this.drugsInOrder[i] = {...drug};
      }
      this.$store.dispatch('orders/setEditNewOrder', {...this.$editNewOrder, drugs: [...this.drugsInOrder]});
      this.$refs.priceDetails.updatePrice();
    },
    updatePrices() {
      this.order.drugs.forEach((d, i) => {
        const priceData = this.getPriceByQty(d);
        this.order.drugs[i].priceData = priceData;
      })
    },
    getPriceByQty(record, projectId = null) {
      const siteId = +this.locality.project_id;
      let discounted = false;
      let price = 0
      let sortedPrices = _.orderBy((record.drug.prices || []), 'qty', 'desc')
      const clearedQty = Math.abs(record.qty)

      sortedPrices.forEach(p => {
        if (price > 0) return
        if (+p.site_id === (projectId || siteId) && clearedQty >= p.qty && p.is_active && price === 0) {
          price = +p.price
          if (p.qty > 1) {
            discounted = true
          }
        }
      })
      if (price === 0) {
        if (!sortedPrices || !sortedPrices.length) {
          toastr['warning'](
            'Препарат ' + (this.drug.title || '') + ' не имеет активной цены'
          )
        }
      }
      if (price === 0) {
        if (+siteId !== 1) {
          price = this.getPriceByQty(record, 1);
        }
      }
      return {price, discounted}
    },
    removeDrug(id) {
      this.order.drugs = this.order.drugs.filter((d) => d.drug.id !== +id);
    },
  }
}

</script>

<style>
.drugSelected .drug_box_info {
  //padding-left: 10px;
}

</style>
<style scoped>
.drugSelected {
  border: 1px solid lightgray;
  margin-bottom: 5px;
}
</style>
